import type { SocialLogin } from '../../../../api/cognito/getSocialLoginUrl';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import type { OAuthSource } from '../../types/general/OAuthSource';

interface OAuthButtonClickedEventArgs {
  analytics: { currentPage: string };
  OAuth: {
    platform: SocialLogin;
    source: OAuthSource;
  };
}

export const sendOAuthButtonClickedEvent = ({
  analytics,
  OAuth,
}: OAuthButtonClickedEventArgs): void => {
  const { currentPage } = analytics;
  const { platform, source } = OAuth;

  void trackEvent({
    name: 'mykiss_auth_button_clicked',
    properties: { action: platform, page: currentPage, type: source, source: 'authentication' },
  });
};
